import { ChevronDoubleDownIcon, ChevronDoubleUpIcon } from "@heroicons/react/24/outline";
import { Dispatch, JSX, SetStateAction } from "react";
import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";

type Props = {
  showContent: boolean;
  setShowContent: Dispatch<SetStateAction<boolean>>
  title: string;
}

/**
 * A toggle bar to show or hide content
 * @param {Props} props
 * @returns {JSX.Element}
 */
function VisibilityBarToggle(props: Props): JSX.Element {
  return (
    <Card className={`${props.showContent? "bg-gray-200 dark:bg-mfdarklighter":"bg-white dark:bg-mfdarklight"}
                      items-center justify-between px-4 shadow-lg select-none h-[50px] rounded-lg my-4 cursor-pointer
                    dark:bg-mfdarklight dark:text-white dark:shadow-gray-950`}
    >
      <motion.div
        whileHover={{ opacity: 0.7 }}
        whileTap={{ scale: 0.99 }}
        transition={{ duration: 0.1 }}
        data-cy="visibilityBarToggle"
        onClick={() => props.setShowContent((prev) => !prev)}
        className={"flex items-center justify-between w-full h-full"}
      >
        {/* Text Container */}
        <div className="font-light text-gray-800 dark:text-gray-100">
          <p>
            {props.title}
          </p>
        </div>

        {/* Icons Container */}
        <div>
          {
            props.showContent ?
              <ChevronDoubleUpIcon data-cy="chevronDoubleUpIcon" className="w-6 mf-text-secondary" />:
              <ChevronDoubleDownIcon data-cy="chevronDoubleDownIcon" className="w-6 mf-text-secondary" />
          }
        </div>
      </motion.div>
    </Card>
  );
}

export default VisibilityBarToggle;
